module.exports = __webpack_public_path__ + "img/AcademyExteriorSunset.626fb4d9.webp";